import React from 'react';
import MarqueeText from './MarqueeText';

export default function WidgetPreview({ config, song }) {
  const cfg = config || {};
  const {
    transparent_bg = true,
    bg_color = '#1a1a2e',
    bg_opacity = 100,
    text_color = '#ffffff',
    accent_color = '#1db954',
    font = 'Inter',
    font_size = 16,
    show_cover = true,
    scroll = true,
    scroll_speed = 40,
    layout = 'horizontal',
    width = 400,
    height = 80,
    show_progress = true,
    show_artist = true,
  } = cfg;

  const hexToRgba = (hex, opacity) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity / 100})`;
  };

  const containerStyle = {
    width,
    height,
    background: transparent_bg ? 'transparent' : hexToRgba(bg_color, bg_opacity),
    fontFamily: font,
    fontSize: font_size,
    color: text_color,
    display: 'flex',
    alignItems: layout === 'horizontal' ? 'center' : 'flex-start',
    flexDirection: layout === 'vertical' ? 'column' : 'row',
    gap: 12,
    padding: '0 12px',
    overflow: 'hidden',
    borderRadius: 8,
    boxSizing: 'border-box',
  };

  const mockSong = song || {
    title: 'Bohemian Rhapsody',
    artist: 'Queen',
    album: 'A Night at the Opera',
    cover_url: null,
    is_playing: true,
    progress_ms: 90000,
    duration_ms: 354000,
  };

  const progress = mockSong.duration_ms > 0
    ? (mockSong.progress_ms / mockSong.duration_ms) * 100
    : 0;

  return (
    <div style={{ background: '#111', padding: 16, borderRadius: 8, display: 'inline-block' }}>
      <div style={containerStyle}>
        {show_cover && (
          <div
            style={{
              width: height * 0.75,
              height: height * 0.75,
              flexShrink: 0,
              borderRadius: 4,
              background: mockSong.cover_url ? 'none' : accent_color,
              overflow: 'hidden',
            }}
          >
            {mockSong.cover_url ? (
              <img src={mockSong.cover_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>
                🎵
              </div>
            )}
          </div>
        )}
        <div style={{ flex: 1, minWidth: 0 }}>
          {scroll ? (
            <MarqueeText speed={scroll_speed} style={{ fontWeight: 600 }}>
              {mockSong.title}
            </MarqueeText>
          ) : (
            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 600 }}>
              {mockSong.title}
            </div>
          )}
          {show_artist && (
            <div style={{ color: accent_color, fontSize: font_size * 0.85 }}>{mockSong.artist}</div>
          )}
          {show_progress && (
            <div style={{ marginTop: 4, height: 3, background: 'rgba(255,255,255,0.2)', borderRadius: 2 }}>
              <div style={{ width: `${progress}%`, height: '100%', background: accent_color, borderRadius: 2 }} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
